module.exports = __webpack_public_path__ + "static/img/logo_name.e05953b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_name.png
// module id = CUqF
// module chunks = 1